<template>
    <div class="modal-content modal--accept">
        <div class="modal-header bg-1">
            <modal-close />
            <div class="modal-title mb-0 mb-md-2">
                <h2 class="h3 mb-0">
                    {{ headerTitle }}
                </h2>
            </div>
        </div>
        <accept-summary
            @addAnotherPromo="onAnotherPromoAdd"
            :modalId="'accept-new-promo-summary'"
        />
    </div>
</template>

<script>
import AcceptSummary from '@/components/promotions/AcceptSummary'

export default {
    components: { AcceptSummary },
    props: {
        onAnotherPromoAdd: {
            type: Function,
            default: () => {}
        }
    },
    computed: {
        headerTitle() {
            const total = +this.$store.getters.getProcessedSubscriptionsTotal
            const accepted = this.$store.getters.getProcessedSubscriptionByType(
                'accepted'
            )

            const acceptedTotalRecords =
                accepted.pagination && accepted.pagination.totalRecords

            let message = 'Dobrze Ci poszło.'
            if (total === acceptedTotalRecords) {
                message = 'Świetnie!'
            } else if (acceptedTotalRecords === 0) {
                message = 'Coś poszło nie tak...'
            }

            return message
        }
    },
    methods: {
        closeModal() {
            this.$store.dispatch('toggleModal', false)
        }
    }
}
</script>
